import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { EditFormLayout } from 'core/layouts';

function ApplicationEditLayoutTemplate({ store, children, disabled, className }) {
    const {
        loaderStore,
        hasPermission
    } = store;

    return (
        <EditFormLayout store={store} loading={loaderStore.loading} layoutFooterVisible={store.rootStore ? true : false} disabled={disabled} hasSubmitPermission={hasPermission} className={className}>
            {children}
        </EditFormLayout>
    )
}

ApplicationEditLayoutTemplate.propTypes = {
    store: PropTypes.object,
    children: PropTypes.any,
    disabled: PropTypes.bool,
    className: PropTypes.any,
    layoutFooterIsVisible: PropTypes.bool,
};

export default defaultTemplate(ApplicationEditLayoutTemplate);
